<template lang="pug">
  .wrap
    page-title Your account

    .section
      .section-title Change your password

      .section-content
        el-row(:gutter="40")
          el-col(:sm="10")
            change-user-password-form(:change-password='changePassword' :show-notify='false'
              ref='changePasswordForm' :require-old-password='true')

        .actions
          el-button(type='primary' @click="submitChangePasswordForm") Change password

</template>

<script>
import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import ChangeUserPasswordForm from "@/shared/components/ChangeUserPasswordForm";
import CrudMixin from "@/shared/mixins/Crud";

export default {
  mixins: [CrudMixin],
  components: { ChangeUserPasswordForm, PageTitle },
  data() {
    return {
      changePassword: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      }
    };
  },
  methods: {
    ...mapActions("auth", ["changeCurrentUserPassword"]),
    submitChangePasswordForm() {
      this.$refs.changePasswordForm.validate(valid => {
        if (!valid) {
          this.$notify({
            title: "Error",
            message: "Please fix the validation errors",
            type: "error"
          });
          return;
        }
        const data = {
          oldPassword: this.changePassword.oldPassword,
          newPassword1: this.changePassword.newPassword,
          newPassword2: this.changePassword.confirmPassword
        };
        this.wrapApiAction(this.changeCurrentUserPassword)({ data }).then(
          () => {
            this.changePassword = { newPassword: "", confirmPassword: "" };
            this.$refs.changePasswordForm.resetFields();
          }
        );
      });
    }
  }
};
</script>

<style scoped lang="scss">
.section {
  background: white;
  padding: 20px;
}

.section-title {
  font-size: 20px;
  margin-bottom: 20px;
}
</style>
